import { Capacitor } from '@capacitor/core';

// Public production identifiers baked into the app so NATIVE builds (iOS/Android)
// never depend on .env files, which are not included in the source ZIP export.
// These are public identifiers (not secrets): a backend domain and a public OAuth
// web client id. On the web build we keep using the environment variables.
const PROD_BACKEND_URL = 'https://app.guestcheckoutapp.com';
const PROD_GOOGLE_WEB_CLIENT_ID =
  '640166023466-t58nc35dithu8o6qiho7tsdlcd40oke9.apps.googleusercontent.com';

const isNativePlatform = Capacitor.isNativePlatform();

export const BACKEND_URL =
  (isNativePlatform ? PROD_BACKEND_URL : process.env.REACT_APP_BACKEND_URL) ||
  PROD_BACKEND_URL;

export const GOOGLE_WEB_CLIENT_ID =
  (isNativePlatform
    ? PROD_GOOGLE_WEB_CLIENT_ID
    : process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID) || PROD_GOOGLE_WEB_CLIENT_ID;

// RevenueCat public iOS SDK key (safe to bake into the app; NOT a secret).
// Fill PROD_REVENUECAT_IOS_PUBLIC_KEY with the key from RevenueCat → API Keys.
const PROD_REVENUECAT_IOS_PUBLIC_KEY = 'appl_QxJnQGwhEJrfzMNwWRELFmrZWGy';
export const REVENUECAT_IOS_PUBLIC_KEY =
  (isNativePlatform
    ? PROD_REVENUECAT_IOS_PUBLIC_KEY
    : process.env.REACT_APP_REVENUECAT_IOS_PUBLIC_KEY) ||
  PROD_REVENUECAT_IOS_PUBLIC_KEY;
